import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { APP } from '@/common/strings'
import { ONBOARDING_COPY } from '@/locales/en'
import { useFrankieOneKycLogic } from './features/kyc/useFrankieOneKycLogic'
import { KycForm } from './features/kyc/components/KycForm'
import { useOnboardingProgress } from './useOnboardingProgress'

export function KycPage() {
    const [kycSubProgress, setKycSubProgress] = useState(0)
    const { progress } = useOnboardingProgress(kycSubProgress)
    const logic = useFrankieOneKycLogic()

    const handleProgressChange = useCallback((subProgress: number) => {
        setKycSubProgress(subProgress)
    }, [])

    // Auto-start KYC on mount if not already started
    const { isKYCStart, isPending, startInitKyc } = logic
    useEffect(() => {
        if (!isKYCStart && !isPending) {
            startInitKyc()
        }
    }, [isKYCStart, isPending, startInitKyc])

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.kyc.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <KycForm
                progress={progress}
                token={logic.token}
                isPending={logic.isPending}
                isError={logic.isError}
                error={logic.error}
                isSuccess={logic.isSuccess}
                isKYCStart={logic.isKYCStart}
                flowContext={logic.flowContext}
                onComplete={logic.onComplete}
                onProgressChange={handleProgressChange}
            />
        </>
    )
}
